import { Component, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { EMPTY, catchError, finalize, first, tap } from 'rxjs';
import { PlatformAccessAuditQuery } from 'src/app/core/models/platform-access/platform-access-audit-query.interface';
import { PlatformAccessAuditEvent } from 'src/app/core/models/platform-access/platform-access-audit-event.interface';
import { PlatformAdminService } from 'src/app/core/services/platform-admin.service';

@Component({
  selector: 'app-admin-access-history',
  templateUrl: './admin-access-history.component.html',
  styleUrls: ['./admin-access-history.component.scss'],
  standalone: false,
})
export class AdminAccessHistoryComponent implements OnInit {
  private readonly platformAdminService = inject(PlatformAdminService);

  public readonly emailControl = new FormControl('', { nonNullable: true });
  public readonly dateFromControl = new FormControl('', { nonNullable: true });
  public readonly dateToControl = new FormControl('', { nonNullable: true });

  public auditEvents: PlatformAccessAuditEvent[] = [];
  public isLoading = false;

  public ngOnInit(): void {
    this.loadAuditEvents();
  }

  public applyFilters(): void {
    this.loadAuditEvents();
  }

  public clearFilters(): void {
    this.emailControl.setValue('');
    this.dateFromControl.setValue('');
    this.dateToControl.setValue('');
    this.loadAuditEvents();
  }

  private loadAuditEvents(): void {
    this.isLoading = true;
    this.platformAdminService
      .getAuditEvents(this.buildAuditQuery())
      .pipe(
        first(),
        tap((auditEvents) => {
          this.auditEvents = auditEvents;
        }),
        catchError(() => {
          this.auditEvents = [];
          return EMPTY;
        }),
        finalize(() => {
          this.isLoading = false;
        }),
      )
      .subscribe();
  }

  private buildAuditQuery(): PlatformAccessAuditQuery {
    const email = this.emailControl.value.trim();
    const dateFrom = this.dateFromControl.value;
    const dateTo = this.dateToControl.value;

    return {
      limit: 50,
      email: email || undefined,
      dateFrom: dateFrom || undefined,
      dateTo: dateTo || undefined,
    };
  }
}
